import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { CustomerClaimsGet, CustomerService, GetCustomerClaimsParams } from '@app/services/customer.service';

@Component({
    selector: 'tt-customer-claims',
    templateUrl: './customer-claims.component.html',
    styleUrls: ['./customer-claims.component.css'],
})
export class CustomerClaimsComponent implements OnInit {
    @Input()
    public params?: GetCustomerClaimsParams;

    public get?: CustomerClaimsGet;

    constructor(
        private customer: CustomerService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    private async loadClaims() {
        if (!this.params) return;

        this.get = await this.customer.getCustomerClaims(this.params);
    }

    public async ngOnInit() {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;
        }

        await this.loadClaims();
    }
}
